// extracted by mini-css-extract-plugin
module.exports = {"item":"item_item_3E-XB","name":"item_name_3mKzY","author":"item_author_7amQ2","cover":"item_cover_2h5VK"};